(function (fox, $, undefined) {
	"use strict";
	var _ = {
		getContentInfo: function () {
			var
				parent = this.getParent(),
				data = {subject: 'content'};

			switch (parent.getClass()) {
				case 'FullscreenView':
					data = {
						targetId: parent.currentPhoto.id,
						subject: 'resource'
					};
					break;
				case 'SitePage_Post':
					data = {
						targetId: parent.rwom1('.PostViewer')._pid,
						subject: 'blog'
					};
					break;
				case 'MC_Photoset_Gallery':
					data.targetId = parent.pid;
					break;
				case 'SitePage_Scene':
					data.targetId = parent.rwom1('.Content_SceneViewer').contentId;
					break;
				case 'Store_Content':
					data = {
						targetId: parent.productId,
						subject: 'store'
					};
					break;
			}

			return data;
		}
	};

	fox.registerWidget('Content_Tipme', {
		configure: function () {
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#content-tipme',
				template: 'content_tipme',
				handleWom: {
					tipsLoaded: {
						event: 'loaded',
						widget: '#tipsDl',
						callback: 'tipsLoaded'
					}
				},
				handleDom: {
					onInput: {
						event: 'input',
						target: '#tip-amount',
						callback: 'onInput'
					},
					tipModel: {
						event: 'click',
						target: '#tip-model',
						callback: 'tipModel'
					}
				},
				widgets: {
					tipItems: {
						widget: 'Widget',
						active: false,
						autoRender: false
					},
					form: {
						container: '@parent #confirmPopup #tipsPopupContainer #content'
					},
					'confirmPopup.widgets.tipsPopupContainer.widgets.content.template': 'content_tipme_confirm'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.amount = this.recomendedCustomPriceAmount;

			this.handleEvent(this.getParent(), 'addedToDom', function (params, scope) {
				$('<div></div>')
					.attr('id', 'biller-form-container')
					.hide()
					.appendTo(scope.element[0]);
			});

			this.callParent('init', arguments);
		},

		running: function () {
			this.loadTips();
			this._readyToRender = false;
			this.rwom1('#confirmPopup #tipsPopupContainer #content')._readyToRender = false;

			this.callParent('running', arguments);
		},

		renderInput: function () {
			this._readyToRender = true;

			this.render();

			this.waitEvent(this, 'addedToDom', function (p, _this) {
				_this._readyToRender = false;
			});

			return this;
		},

		loadTips: function () {
			this.rwom1('#tipsDl').load();

			return this;
		},

		tipsLoaded: function (p, dl) {
			this.tipOption = dl.getCollection().filter(function (v) {
				return Number(v.type) === 1;
			}).pop();

			if (this.tipOption) {
				this.renderInput();
			}
		},

		activate: function () {
			if (this.tipOption) {
				this.renderInput();
			}

			this.callParent('activate', arguments);
		},

		addedToDom: function () {
			var
				$i = $(this.dom1('#tip-amount'));

			$i.parent().addClass('in-dom');
			$i.attr('placeholder', ['$', this.amount].join(''));
		},

		onInput: function (el) {
			el.value = el.value.replace(/[\$\.,]+/, '');

			var v = el.value;

			if (this.validateAmount(v)) {
				this.amount = Number(v);
			}
		},

		tipModel: function () {
			var f = this.rwom1('#form'),
				confirm = this.rwom1('#confirmPopup');

			f.setValue('amount', this.amount);

			this.renderConfirmContent({amount: this.amount});

			confirm.show();
		},

		renderConfirmContent: function (templateOptions) {
			var w = this.rwom1('#confirmPopup #tipsPopupContainer #content');

			w._readyToRender = true;
			w.setTemplateOptions(templateOptions);
			w.render();

			this.waitEvent(w, 'addedToDom', function (p, _w) {
				_w._readyToRender = false;
			});
		},

		validateAmount(value) {
			var $el = $(this.dom1('#tip-amount')).parent(),
				$btn = $(this.dom1('#tip-model'));

			if (Number(value) > this.minCustomPriceAmount - 1 && Number(value) < 99999) {
				var errorEl = $el.hasClass('error') && $el.removeClass('error');
				$btn.prop('disabled', false);

				return true;
			} else if (!value) {
				this.amount = this.recomendedCustomPriceAmount;
				var errorElt = $el.hasClass('error') && $el.removeClass('error');
				$btn.prop('disabled', false);

				return false;
			} else {
				$el.addClass('error');
				$btn.prop('disabled', true);

				return false;
			}
		},

		onSubmit() {},
		_validateCustomValue() { return true; },

		submit(resolver = () => {}) {
			const form = this.rwom1('#form');

			this.validateData();

			if (!this._isValid)
				return fox.isFunction(resolver) && resolver(false);

			this.userData = form.collectData();
			this.userData.amount = this.amount;
			this.userData.tips = this.tipOption.id;

			fox.merge(this.userData, _.getContentInfo.call(this));

			return this.callParent('submit', arguments).then(function () {
				form.resetForm();

				if (fox.isFunction(resolver))
					resolver(true);
			}).catch(() => {
				if (fox.isFunction(resolver))
					return resolver(false);
			});
		}

	}, 'Tips_Form');

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/content/tipme.es.js